import {
    getList,
    getListCount,
    getItem,
    postItem,
    deleteItem,
    putItem,
} from "./utils/entity-network-requests"

const entityName = "topic"

// Topic List
export const getTopicList = (token, parameters) =>
    getList(entityName, parameters, token)
export const getTopicListCount = (token, parameters) =>
    getListCount(entityName, parameters, token)

// Topic Entity
export const getTopicItem = (token, id) => getItem(entityName, id, token)
export const putTopicItem = (token, id, topic) =>
    putItem(entityName, id, topic, token)
export const postTopicItem = (token, topic) =>
    postItem(entityName, topic, token)

// Topic Mappings
export const postTopicPreviewMapping = (token, topicId, previewMapping) =>
    postItem(
        `${entityName}${topicId ? "/" + topicId : ""}/preview`,
        previewMapping,
        token
    )
export const deleteTopicPreviewMapping = (token, topicId, mappingId) =>
    deleteItem(`${entityName}/${topicId}/preview`, mappingId, token)

// Topic Reports
export const getTopicReports = (token, topicId, parameters) =>
    getList(`${entityName}/${topicId}/report`, parameters, token)

// Topic Fingerprint
export const getTopicFingerprint = (token, topicId, parameters) =>
    getList(`${entityName}/${topicId}/fingerprint`, parameters, token)

// Topic FP Builder
export const postTopicFPBuilder = (token, parameters) =>
    postItem(`${entityName}/fp_builder`, parameters, token)

// Topic Salesforce Sync
export const postTopicSync = (token, topicId) =>
    postItem(`${entityName}/${topicId}/cypher`, null, token)
